import React, { useMemo } from "react";
import {  useSelector } from "react-redux"
import { selectProcedure } from "../../../selectors";
import { useUpdateEffect } from "../../../../hooks";
import { useValidateDepartModeUsingExitOffice } from "../../../hooks/useValidateDepartModeUsingExitOffice";

const DepartureTransportMode=({saveData :save,onUpdate:update,renderForm,modeType,title,isImportShipment})=>{
  
  const procedure = useSelector(selectProcedure);
  const dataSource=useSelector((state)=>state.Shipment.transportation[modeType])
  const {motValidationMsg}=useValidateDepartModeUsingExitOffice()
  
  const saveData=(payload)=>{
    if(payload.hasOwnProperty("typeId") && !payload.typeId?.trim() && !isImportShipment){
        payload.nationality=" "
    }
      save(payload)
  }
  const onUpdate=(payload)=>{
      if(payload.hasOwnProperty("typeId") && !payload.typeId?.trim() && !isImportShipment){
          payload.nationality=""
      }
      update(payload)
  }
  
  const OnMotChange=({value,...rest})=>{
    
    if(["5","7"].includes(value)){
        if(isImportShipment){
            saveData({mot:value,type:" ",typeId:" ",...rest})
            onUpdate({mot:value?.trim(),type:"",typeId:"",...rest})
     
        }
        else{
            saveData({mot:value,"nationality":" ",typeId:" ",type:" ",...rest})
            onUpdate({mot:value?.trim(),"nationality":"",typeId:"",type:"",...rest})
        }
    }
    else{
    saveData({mot:value,type:" ",...rest})
    onUpdate({mot:value?.trim(),type:"",...rest})
    }
  }
  const {validationMsg,disableForm,isTransNationalityVisible,isMotTypeIdVisible,isMotTypeVisible,TransNationalityErrorMessage}=useMemo(()=>{
         
    const response={}
   
   
    if(isImportShipment){
            if(["5","7"].includes(dataSource.mot)){
          response.isMotTypeVisible=true
          response.isMotTypeIdVisible=true
         
        }
        response.isTransNationalityVisible=true
        response.validationMsg=<ul>
          <li>
          if MOT is 5 or 7 then MOT Type and MOT Type Identification will be disabled.</li>
          <li>For all MOT types nationality will be disabled </li></ul>
    }
    else{
          if(["5","7"].includes(dataSource.mot)){
          response.isMotTypeIdVisible=true
          response.isTransNationalityVisible=true
        }
         const isTransNationalityDisabled=dataSource.typeId ? false : true
         response.isTransNationalityVisible=isTransNationalityDisabled
         response.TransNationalityErrorMessage=!isTransNationalityDisabled ? "Nationality is mandatory" : ""

        if(["B4"].includes(procedure)){
          response.disableForm=true
        }
        response.validationMsg=
        <ul><li>if MOT is 5 or 7 then nationality and MOT Type Identification will be disabled.</li>
        <li>if Procedure Code is B4 then this section will be disabled</li></ul>
      }

    return response
},[dataSource.mot,procedure,isImportShipment,dataSource.typeId])



  useUpdateEffect(()=>{

     if(disableForm && dataSource.transportId){
    save({mot:" ",type:" ",typeId:" ",nationality:" ",description:" ",modeType,transportId:dataSource.transportId})
    update({modeType,mot:"",type:"",typeId:"",nationality:"",description:"",modeType,transportId:dataSource.transportId})
  }
  },[disableForm])

   return renderForm && renderForm({
    title,
    modeType,
    disableFields:{type:isMotTypeVisible,typeId:isMotTypeIdVisible,nationality:isTransNationalityVisible},
    errorInfo:{nationality:!isTransNationalityVisible && !dataSource.nationality && TransNationalityErrorMessage,mot:motValidationMsg},
    disableForm,
    validationMsg,
    saveData,
     dataSource, 
     onUpdate,
     onMotChange:OnMotChange,
   })


}

export default React.memo(DepartureTransportMode)
